module.exports = __webpack_public_path__ + "img/pd_b1_img1.70970f7f.png";